<mat-drawer-container style="margin:0;padding:0" class="example-container" (backdropClick)="sidenavToggleFn()"  autosize [hasBackdrop]="false">
    <mat-drawer #drawer class="example-sidenav" mode="side" >
      <div  class="drawer-style">
        <div  class="sidenavTitleArea" style="margin: 15px;">
            <button  mat-icon-button 
            (click)="sidenavToggleFn()"
            class="example-icon">
              <mat-icon class="example-icon">menu</mat-icon>
            </button>
          <h3>Vanuatu</h3>
            
        </div>
        
      </div>
        <div *ngFor="let element of sidenavElements;index as i" (click)="goToElement(i)" class="elements-div">
            <mat-icon style="margin-right: 10px">{{iconsArr[i]}}</mat-icon><span>   </span>{{element}}
        </div>
     
    </mat-drawer>
  
    <div class="example-sidenav-content">
      <app-toolbar [sidenavToggleState]="showSidenav" (sidenavToggleEvent)="sidenavToggleFn()"></app-toolbar>
      <div style="height: 100px;background-color: #B2EBF2;margin-top:-12px !important; position: sticky;z-index: 3;">
      </div>
      <router-outlet></router-outlet>  

    </div>
  
  </mat-drawer-container>
  